const useMessages = () => {
    const toast = useToast()

    const showSuccessMessage = (title = '', description = '', timeout = 0) => {
        toast.add({
            title: title,
            description: description,
            icon: 'i-bi-check-circle',
            color: 'success',
            timeout: timeout
        })
    }

    const showErrorMessage = (title = '', description = '', timeout = 0) => {
        toast.add({
            title: title,
            description: description,
            icon: 'i-bi-x-circle',
            color: 'danger',
            timeout: timeout
        })
    }

    const showWarningMessage = (title = '', description = '', timeout = 0) => {
        toast.add({
            title: title,
            description: description,
            icon: 'i-bi-exclamation-triangle',
            color: 'warning',
            timeout: timeout
        })
    }

    const showInfoMessage = (title = '', description = '', timeout = 0) => {
        toast.add({
            title: title,
            description: description,
            icon: 'i-bi-exclamation-circle',
            color: 'info',
            timeout: timeout
        })
    }

    const showQuestionMessage = (title = '', description = '', timeout = 0) => {
        toast.add({
            title: title,
            description: description,
            icon: 'i-bi-question-circle',
            color: 'help',
            timeout: timeout
        })
    }

    return {
        showSuccessMessage,
        showErrorMessage,
        showWarningMessage,
        showInfoMessage,
        showQuestionMessage
    }
}

export default useMessages
